import { ChainAddressType as R } from "../../temp-lib/constants/chain.js";
import { WalletType as B } from "../../temp-lib/constants/web3.js";
import { useAccountContext as b } from "../../temp-lib/contexts/account/AccountContext.js";
import { isIosOrAndroid as x } from "../../temp-lib/util/browser/index.js";
import { createStrictContext as O } from "../../temp-lib/util/context/createStrictContext.js";
import h from "../components/OpenRoninWalletAppSnackBar.js";
import { MobileWalletSnackBarMode as n } from "../constants/index.js";
import y from "../hooks/useWalletConnect.js";
import { useRef as N, useState as d, useCallback as l, useEffect as v } from "react";
import { jsxs as I, jsx as L } from "react/jsx-runtime";
const [P, G] = O("RoninWalletSnackBar"), H = (u) => {
  const {
    children: C
  } = u, c = N(n.None), {
    openRoninMobileWallet: s,
    roninQRCode: i,
    getDeepLink: p
  } = y(), {
    loginByWallet: f,
    isLoggedIn: a,
    isWalletConnected: t
  } = b(), [r, S] = d(n.None), m = (e) => {
    c.current = e, S(e);
  }, [k, o] = d(!1), M = l((e) => {
    o(!0), m(e);
  }, []), W = l((e, A) => {
    A !== "clickaway" && o(!1);
  }, []);
  v(() => {
    const e = c.current === n.Connect;
    t && !a && x() && e && (m(n.SignMessage), o(!0));
  }, [t, a]);
  const g = l(async () => {
    r === n.None || r === n.SignTransaction ? (s(), o(!1)) : i && !t ? (s(p()), o(!1)) : t && !a && (await f(B.RoninMobile, R.RONIN), o(!1));
  }, [r, i, t, a, s, p, f]);
  return /* @__PURE__ */ I(P, {
    value: {
      openSnackBar: M
    },
    children: [C, /* @__PURE__ */ L(h, {
      open: k,
      onClose: W,
      onOpenApp: g,
      mode: r,
      loading: r === n.Connect && !i
    })]
  });
};
export {
  H as RoninWalletSnackbarProvider,
  G as useRoninWalletSnackBarContext
};
//# sourceMappingURL=RoninWalletSnackbarContext.js.map
